import { render, staticRenderFns } from "./OrdensServicoFormSalvar.vue?vue&type=template&id=1c777cc0&scoped=true&"
import script from "./OrdensServicoFormSalvar.vue?vue&type=script&lang=js&"
export * from "./OrdensServicoFormSalvar.vue?vue&type=script&lang=js&"
import style0 from "./OrdensServicoFormSalvar.vue?vue&type=style&index=0&id=1c777cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c777cc0",
  null
  
)

export default component.exports